import React from "react";
import '../../../App.css';
import { NavLink } from "react-router-dom";


const PaymentOptionCard = (props) => {
    return (
        <NavLink className="Payment-option-card" to={props.to}>
            {/* <div style={{ textAlign: 'center', margin:10, }}>
                <img src={props.img} width={props.width} height={props.height} style={{borderRadius:25}}/>
            </div> */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: '#2E5266FF', fontSize: 36 }}>
                <div>{props.name}</div>
                
            </div>
        </NavLink>
    )
}


export default PaymentOptionCard;